import axios from "axios";
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import { baseURL } from "../../api/agent";
import store from "../store/store";
import {
  addShopifyAccessToken,
  setIsSyncCompleted,
} from "../reducer/features/Integration/DmsSetupSlice";
import {
  incrementUnreadOrders,
  incrementUnreadQuotes,
} from "../reducer/features/Dashboard/DashboardSlice";
import { setBulkPriceSyncing } from "../reducer/features/Auth/authSlice";
import { ProductType } from "../../models/features/Integration/DmsSetup";

export function storeMiddleware(store: any) {
  return (next: any) => (action: any) => {
    switch (action.type) {
      default:
    }

    return next(action);
  };
}

// export function signalRInit(callback: Function) {
//   hubConnection.onclose((error) => {
//     if (typeof error !== "undefined") {
//       console.log("(onclose) Error: " + error.name + " : " + error.message);
//     } else {
//       console.log("(onclose) No error to show while closing the connection.");
//     }
//     console.log("Hub connection closed");
//   });

//   hubConnection.onreconnecting((error) => {
//     console.log("Reconnecting to hub", error?.name + ":" + error?.message);
//   });

//   hubConnection.onreconnected((connectionId) => {
//     console.log("Connection to hub restored");
//   });

//   hubConnection.on("newMessage", (status: string) => {
//     console.log("msg receive");
//     console.log("Msg receive" + status);
//     //toast.info(status);
//   });
// }

// export function signalRClose() {
//   hubConnection.stop();
// }

export function signalRStart(groupName: string[], callback: Function) {
  var accessToken = store.getState().authReducer.targetWebAccessToken;
  axios
    .post(
      `${baseURL}api/negotiate`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    .then((res: any) => {
      const hubConnection: HubConnection = new HubConnectionBuilder()
        .withUrl(`${res.data.url}`, {
          accessTokenFactory: () => res.data.accessToken,
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build();

      hubConnection
        .start()
        .then(() => {
          console.log(
            "Connection to notification hub established",
            hubConnection
          );
          callback();
          hubConnection.on("synced-product", (response: any) => {
            store.dispatch<any>(
              setIsSyncCompleted({ status: response.isSyncCompleted })
            );
          });

          hubConnection.on("new_order", (response: any) => {
            store.dispatch<any>(incrementUnreadOrders(response.newOrdersCount));
          });

          hubConnection.on("new_lead", (response: any) => {
            store.dispatch<any>(
              incrementUnreadQuotes(response.newQuotationsCount)
            );
          });
          hubConnection.on("bulk_operation", (response: any) => {
            store.dispatch<any>(
              setBulkPriceSyncing({
                isSyncing: !(response?.isBulkOperationCompleted ?? true),
                productType: ProductType.Wholegoods,
              })
            );
            store.dispatch<any>(
              setBulkPriceSyncing({
                isSyncing: !(response?.isBulkOperationCompleted ?? true),
                productType: ProductType.Parts,
              })
            );
          });

          hubConnection.on("Shopify_Installation", (response: any) => {
            console.log("Shopify_Installation response", response);
            store.dispatch<any>(
              addShopifyAccessToken({
                token: response?.shopifyOAuthAccessToken || "",
              })
            );
          });

          groupName.forEach((group) => {
            axios
              .post(
                `${baseURL}api/JoinGroup`,
                {
                  connectionId: hubConnection.connectionId,
                  groupName: group,
                },
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                }
              )
              .then((res) => {
                console.log("join group", group);
              });
          });
        })
        .catch((error) => {
          console.log("Error establishing the connection to the Hub");
        });
    });
}
